// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","246":"319dd68b","386":"979ed6eb","458":"fa58432f","462":"9fee48eb","577":"66801e42","652":"34876035","682":"d5252985","783":"c66ca607","812":"e16e9c63","867":"b3f68256","904":"0c67cfd9","985":"de897744","997":"f8c56c24"}[chunkId] + ".js";
};